<div class="popup g-popup" (cmsEscapeKey)="closePopup()">
    <header class="g-popup-header">
        <i (click)="closePopup()" class="g-popup-header-close g-icon g-icon-close-a"></i>
        <div class="g-popup-title">{{'applications_edit_application_template' | translate}}</div>
    </header>
    <div class="g-popup-body">
        <form class="popup-form" novalidate [formGroup]="appTemplate" (ngSubmit)="$submit.next($event)">
            <div class="form-body">
                <div class="form-control">
                    <div class="g-input g-input-io"
                         [ngClass]="{invalid: (appTemplate.get('name').hasError('required') || appTemplate.get('name').hasError('maxlength') || appTemplate.get('name').hasError('pattern')) && !appTemplate.get('name').pristine}">
                        <input type="text" class="g-input-input" [placeholder]="'common_name' | translate" formControlName="name">
                        <label class="g-input-label">{{ 'common_name' | translate }}</label>
                        <label class="g-input-validation">
                            <span *ngIf="appTemplate.get('name').hasError('required')">
                                {{ 'common_validation_field_required' | translate }}
                            </span>
                            <span *ngIf="appTemplate.get('name').hasError('maxlength') && !appTemplate.get('name').hasError('pattern')">
                                {{'common_validation_maximum_field_length' | translate: nameValidationInterpolationParams}}
                            </span>
                            <span *ngIf="appTemplate.get('name').hasError('pattern')">
                                {{'common_validation_valid_characters' | translate: nameValidationInterpolationParams}}
                            </span>
                        </label>
                    </div>
                </div>
                <div class="form-control">
                    <div class="g-input g-input-io"
                         [ngClass]="{invalid: (appTemplate.get('title').hasError('required') || appTemplate.get('title').hasError('maxlength')) && !appTemplate.get('title').pristine}">
                        <input type="text" class="g-input-input" [placeholder]="'common_title' | translate" formControlName="title">
                        <label class="g-input-label">{{ 'common_title' | translate }}</label>
                        <label class="g-input-validation">
                            <span *ngIf="appTemplate.get('title').hasError('required')">
                                {{ 'common_validation_field_required' | translate }}
                            </span>
                            <span *ngIf="appTemplate.get('title').hasError('maxlength')">
                                {{'common_validation_maximum_field_length' | translate: titleValidationInterpolationParams}}
                            </span>
                        </label>
                    </div>
                </div>
                <div class="form-control">
                    <div class="g-input g-input-io">
                        <input type="text" class="g-input-input" [placeholder]="'application_templates_name_template' | translate" formControlName="nameTemplate">
                        <label class="g-input-label">{{ 'application_templates_name_template' | translate }}</label>
                    </div>
                </div>
            </div>
            <div class="form-footer">
                <div class="form-footer-buttons">
                    <button type="submit" class="form-footer-button g-button g-button-earth"
                            [disabled]="appTemplate.invalid || !fieldsChanged">
                        <span class="g-button-title">{{ 'common_save' | translate }}</span>
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>
